import React from 'react';
import ReactDOM from 'react-dom/client';
import { getRegistryConfig } from './registryConfig';
import RegistryRoot from './RegistryRoot';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RegistryRoot config={getRegistryConfig()} />
  </React.StrictMode>,
);
